const Clinic = ({ clinic }: { clinic: string }) => (
  <div className="summary-item-box">
    <div className="row">
      <div className="summary-txt-box type-5">{clinic}</div>
    </div>
  </div>
);
export default Clinic;
